import React from 'react';

import {Link} from 'react-router';

import {UserAvatar} from 'app/components/general/avatars';
import {printContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';

import {FixableHeader, FixableTable} from './utils';

import type {
  BasicUserSerializedType,
  DocTaskReportItemType,
  DocumentContentType,
  ReportResultSerializedType,
} from 'sweet-types';

interface RowType extends DocTaskReportItemType {
  name: string;
  content_type: DocumentContentType;
  requester: BasicUserSerializedType;
  pending_approvers: Array<BasicUserSerializedType>;
  html_url: string;
}

interface Props {
  result: ReportResultSerializedType<RowType>;
}

export function RenderPendingApprovalDocuments({result}: Props): JSX.Element {
  return (
    <FixableTable>
      <thead>
        <tr>
          <FixableHeader>{gt('Name')}</FixableHeader>
          <FixableHeader>{gt('Document type')}</FixableHeader>
          <FixableHeader>{gt('Teams')}</FixableHeader>
          <FixableHeader>{gt('Requester')}</FixableHeader>
          <FixableHeader>{gt('Pending Approvers')}</FixableHeader>
        </tr>
      </thead>
      <tbody>
        {result.results.map((r, i) => (
          <tr key={i}>
            <td>
              <Link className="font-weight-bold" to={r.html_url}>
                {r.name}
              </Link>
            </td>
            <td>{printContentType(r.content_type)}</td>
            <td>
              <ul className="mb-0 pl-4">
                {r.teams.map((t) => (
                  <li key={t.html_url}>
                    <Link to={t.html_url}>{t.name}</Link>
                  </li>
                ))}
              </ul>
            </td>
            <td>
              <div className="d-flex">
                <UserAvatar user={r.requester} small />
                <div className="ml-2">
                  <div>{r.requester.name}</div>
                </div>
              </div>
            </td>
            <td>
              <ul className="mb-0 pl-4">
                {r.pending_approvers.map((user) => (
                  <li key={user.id} className="d-flex">
                    <UserAvatar user={user} small />
                    <div className="ml-2">
                      <div>{user.name}</div>
                    </div>
                  </li>
                ))}
              </ul>
            </td>
          </tr>
        ))}
      </tbody>
    </FixableTable>
  );
}
